(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sani-donna-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sani-size-guide')) {
  customElements.define('sani-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-size-guide-open]');
      if (!dialog || !trigger) return;
      trigger.addEventListener('click', () => dialog.showModal());
      this.querySelector('[data-size-guide-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sani-home-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Set();
  const selector = '.sh-models .sh-section-header>div,.sh-models .sh-model,.sh-model-quality,.sh-everyday-copy>*,.sh-everyday-photo,.sh-brand--world .sw-header>*,.sh-brand--world .sw-copy>*,.sh-brand--world .sw-visual,.sh-home-b2b-copy>*,.sh-home-catalogs';
  const show = element => {
    element.classList.add('sh-reveal-visible');
    pending.delete(element);
    observer?.unobserve(element);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) show(entry.target); });
  }, { threshold: .08, rootMargin: '0px 0px -16px 0px' }) : null;
  function init(root = document) {
    if (!observer || preference.matches) return;
    root.querySelectorAll(selector).forEach(element => {
      if (element.dataset.shRevealed) return;
      element.dataset.shRevealed = 'true';
      if (element.getBoundingClientRect().bottom <= 0) return;
      const siblings = [...element.parentElement.children].filter(child => child.matches(selector));
      const index = siblings.indexOf(element);
      element.style.setProperty('--sh-reveal-delay', Math.min(Math.max(index, 0), 3) * 65 + 'ms');
      if (element.matches('.sh-model,.sh-everyday-photo,.sw-visual,.sh-home-catalogs')) {
        element.style.setProperty('--sh-reveal-x', index % 2 ? '12px' : '-12px');
      }
      element.classList.add('sh-reveal-pending');
      pending.add(element);
      observer.observe(element);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    pending.forEach(element => {
      if (event.target.contains(element)) { observer?.unobserve(element); pending.delete(element); }
    });
  });
  preference.addEventListener('change', event => { if (event.matches) [...pending].forEach(show); });
  document.addEventListener('focusin', event => {
    const element = event.target.closest('.sh-reveal-pending');
    if (element) show(element);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sani-mobile-drawer-style"] && !Shopify.designMode) return;
  try {
    window.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('[data-sani-account-link]') : null;
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (link.dataset.saniAccountPreview === 'true') {
    window.open(link.href, '_blank', 'noopener');
  } else {
    window.location.assign(link.href);
  }
}, { capture: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sani-review-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const trigger = event.target.closest?.('[data-review-photo-open]');
  if (trigger) {
    const dialog = trigger.closest('.sani-review-photo')?.querySelector('dialog');
    if (dialog && !dialog.open) dialog.showModal();
    return;
  }
  const dialog = event.target;
  if (dialog instanceof HTMLDialogElement && dialog.classList.contains('sani-review-photo__dialog')) {
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sani-uomo-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sani-size-guide')) {
  customElements.define('sani-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-size-guide-open]');
      if (!dialog || !trigger) return;
      trigger.addEventListener('click', () => dialog.showModal());
      this.querySelector('[data-size-guide-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
